/**
 * DESIGN.md, "Motion": where script animates (the Web Animations API takes
 * numbers, not CSS), the motion tokens are read from the page. A time token
 * may reach the page in seconds: the built stylesheet writes 280ms as `.28s`.
 */
export function cssTime(value: string): number {
  const text = value.trim()
  const amount = Number.parseFloat(text)
  if (!Number.isFinite(amount) || amount < 0) return 0
  if (text.endsWith('ms')) return amount
  if (text.endsWith('s')) return Math.round(amount * 1000)
  return 0
}

/** One token as the element sees it, trimmed: empty when it has none. */
export const cssToken = (style: CSSStyleDeclaration, name: string) =>
  style.getPropertyValue(name).trim()

/**
 * An entrance through Element.animate. An engine that refuses one of its
 * values throws, and a screen must never stop for a motion: it shows still.
 */
export function animate(
  element: Element,
  keyframes: Keyframe[],
  options: KeyframeAnimationOptions,
) {
  try {
    element.animate(keyframes, options)
  } catch {
    // Nothing to undo: the element is drawn as it is, without the motion.
  }
}
